import React from "react";
import { SVG, IconProps } from "../SVG";

export const SpotHeartHand = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 56 56" {...props}>
        <g clipPath="url(#heart_hands_spot_56_svg__a)">
            <path
                fill={spotColor}
                d="M6.8 24.892C9.233 17.77 17.882 11.19 25.522 8.66c7.675-2.545 16.77-.506 22.796 5.444s8.963 14.856 7.15 22.358c-1.764 7.524-8.06 12.05-13.602 14.815-5.576 2.78-10.398 2.79-16.153 1.397-5.772-1.343-11.621-3.558-14.627-8.765C8.081 38.7 4.332 32.029 6.8 24.892Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.4}
                d="M45.252 23.694c-1.747-1.977-1.815-3.53-.724-4.706 1.09-1.176 2.668-.525 3.471.341l1.942 2.093c.72-5.36-.28-10.02-3.053-12.676a10.97 10.97 0 0 0-4.314-2.476 10.425 10.425 0 0 0-4.882-.261 12.203 12.203 0 0 0-5.29 2.538 13.437 13.437 0 0 0-3.683 4.817.909.909 0 0 1-.315.286.855.855 0 0 1-1.123-.286 13.437 13.437 0 0 0-3.683-4.817 12.202 12.202 0 0 0-5.291-2.538 10.425 10.425 0 0 0-4.882.26 10.97 10.97 0 0 0-4.314 2.477C6.34 11.403 5.34 16.062 6.058 21.422L8 19.33c.804-.866 2.381-1.517 3.472-.341 1.09 1.175 1.022 2.729-.724 4.706m34.504 0c-.381-.431-1.634-1.757-2.603-2.806-1.393-1.508-3.392-2.488-4.846-.92-1.454 1.567-.545 3.722.545 4.898l1.454 1.567m5.45-2.74 3.481 3.753m-11.217 4.587c-2.908-3.135-3.53-4.816-2.076-6.384 1.454-1.567 3.214-.454 4.362.784m-2.286 5.6c-2.181-2.351-3.658-1.543-4.257-.898-.598.646-1.339 2.228.37 4.07l5.545 5.987A81.508 81.508 0 0 1 28 50.167a81.515 81.515 0 0 1-11.175-8.975l5.546-5.988c1.708-1.841.968-3.423.37-4.069-.6-.645-2.076-1.453-4.257.898m19.032 0 4.998 5.389m3.422-4.377-6.134-6.612m-29.054-2.74c.38-.43 1.634-1.756 2.602-2.805 1.393-1.508 3.392-2.488 4.846-.92 1.454 1.567.546 3.722-.545 4.898l-1.454 1.567m-5.45-2.74-3.48 3.753m11.217 4.587c2.908-3.135 3.53-4.816 2.075-6.384-1.454-1.567-3.214-.454-4.362.784m2.287 5.6-4.999 5.389m-3.421-4.377 6.133-6.612"
            />
        </g>
        <defs>
            <clipPath id="heart_hands_spot_56_svg__a">
                <path fill="#fff" d="M0 0h56v56H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotHeartHand.displayName = "SpotHeartHand";
